import type { NavItem } from '@/types/landing'

/** 落地页导航项 */
export const navItems: NavItem[] = [
  { label: '功能特性', anchor: '#features' },
  { label: '场景方案', anchor: '#scenarios' },
  { label: '客户案例', anchor: '#testimonials' },
  { label: '帮助文档', anchor: '#docs' },
  { label: '活动资讯', anchor: '#news' },
]
